// removed by extract-text-webpack-plugin
module.exports = {"edit-box-input":"companyInfo__edit-box-input___zGtRU","edit-box-span":"companyInfo__edit-box-span___1FQIU"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Setup/CompanyInfo/companyInfo.less
// module id = 1386
// module chunks = 3